import { UserEurosStep } from "@api/models/User";
import StringHelper from "@helpers/StringHelper";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Flex, Stack, ThemeIcon } from "@mantine/core";
import useUserStore from "@store/user.store";
import { IconMapPinFilled } from "@tabler/icons-react";
import ClientDashboardTitle from "./components/ClientDashboardTitle";
import CoinCard from "./components/CoinCard";
import Coins, { ECoinVariant } from "./components/Coins";
import CurrentStepProgressCard from "./components/CurrentStepProgressCard";
import NextUserRewardCard from "./components/NextUserRewardCard";
import ContainerCard from "./components/container/ContainerCard";
import ContainerText from "./components/container/ContainerText";
import StepCards from "./components/stepCards/StepCards";

const Fidelity: React.FC = () => {
  const { affiliationInformation } = useUserStore();
  const { t } = useAppTranslation("pages.clientDashboard");
  const user = new UserEurosStep(
    affiliationInformation?.totalAmountBoughtInEuros ?? 0,
  );

  return (
    <Stack gap={20} classNames={{ root: "max-w-[1200px]" }}>
      {/* title page */}
      <ClientDashboardTitle
        icon={<Coins variant={ECoinVariant.FIDELITY} size={40} />}
        label={t("fidelity.title")}
        subHeader={t("fidelity.subHeader")}
      />

      {/* 1st row */}
      <Flex className="flex-wrap items-stretch gap-[20px]">
        <CoinCard
          containerProps={{
            classNames: {
              root: "w-full sm:w-auto",
              wrapper: "w-full sm:w-auto",
            },
          }}
        />
        <ContainerCard
          title={t("fidelity.howItWorks.title")}
          classNames={{ root: "flex-1 min-w-[min(80%,300px)]" }}
        >
          <ContainerText>{t("fidelity.howItWorks.text")}</ContainerText>
        </ContainerCard>
      </Flex>

      {/* 2nd row */}
      <Flex gap={20} className="flex-wrap items-stretch justify-center">
        <div className="w-full sm:mx-auto sm:w-fit">
          <ContainerCard
            title={t("fidelity.status")}
            classNames={{
              root: "min-w-[200px] w-full md:w-fit h-full",
              wrapper: `${user.currentStepTextClasses} text-2xl flex flex-row items-center justify-center gap-[5px] font-mona font-semibold`,
            }}
          >
            <ThemeIcon
              variant="transparent"
              className={user.currentStepTextClasses}
              size={25}
            >
              <IconMapPinFilled />
            </ThemeIcon>{" "}
            {StringHelper.capitalizeFirstLetter(user.currentStep)}
          </ContainerCard>
        </div>
        <div className="w-max min-w-[min(80%,450px)] flex-1">
          <CurrentStepProgressCard
            containerProps={{ classNames: { root: "h-full w-full" } }}
          />
        </div>
        <div className="w-max min-w-[min(80%,450px)] flex-1">
          <NextUserRewardCard
            containerProps={{ classNames: { root: "h-full w-full" } }}
          />
        </div>
      </Flex>

      {/* 3rd row */}
      <StepCards />
    </Stack>
  );
};

export default Fidelity;
